"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _core = require("@focaltec-suite/core");
var _api = require("@focaltec-suite/api");
var _components = require("../components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function FeedbackErrorPopup(_ref) {
  var error = _ref.error,
    onClose = _ref.onClose;
  var data = (0, _react.useMemo)(function () {
    if (!error) return;
    if (error instanceof _api.CustomError && error.apiError) {
      return {
        code: error.apiError.code,
        description: error.apiError.resource === 'network' ? error.message : error.apiError.description,
        service: error.apiError.resource
      };
    }
    return {
      code: 0,
      description: error.message,
      service: 'network'
    };
  }, [error]);
  return /*#__PURE__*/_react["default"].createElement(_components.DialogPopup, {
    open: !!error,
    variant: "warning",
    title: (0, _core.translate)('feedback_error.title'),
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    container: true,
    spacing: 3,
    alignItems: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "h1",
    sx: {
      m: 0,
      p: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_components.BrokenIcon, {
    fontSize: "inherit",
    color: "warning"
  }))), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body1",
    paragraph: true
  }, (0, _core.translate)('feedback_error.paragraph1')), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    paragraph: true
  }, (0, _core.translate)('feedback_error.paragraph2')), /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    sx: {
      mb: 1
    }
  }), /*#__PURE__*/_react["default"].createElement(_components.DetailList, {
    textAlign: "right",
    items: [{
      title: (0, _core.translate)('feedback_error.description'),
      data: data === null || data === void 0 ? void 0 : data.description
    }, {
      title: (0, _core.translate)('feedback_error.service'),
      data: data === null || data === void 0 ? void 0 : data.service
    }, {
      title: (0, _core.translate)('feedback_error.code'),
      data: data === null || data === void 0 ? void 0 : data.code
    }]
  }), /*#__PURE__*/_react["default"].createElement(_material.Divider, {
    sx: {
      mt: 1,
      mb: 2
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, (0, _core.translate)('feedback_error.footer')))));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FeedbackErrorPopup);